import DraftOrderShowPage from '../../components/pages/draft_orders/DraftOrderShowPage'
export default {
  components: { DraftOrderShowPage }
}
